"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var escapeRegex_1 = __importDefault(require("../escapeRegex"));
/**
* Replace all matched occurrence with the given string
*
* @param   string searchText
* @param   string replacement
* @returns string
*/
function replaceAll(string, searchText, replacement) {
    return string.replace(new RegExp(escapeRegex_1.default(searchText), 'g'), replacement);
}
exports.default = replaceAll;
;
//# sourceMappingURL=replaceAll.js.map